module.exports = __webpack_public_path__ + "img/60.55dda9f8.png";